module.exports = __webpack_public_path__ + "img/小雨-中雨.936b0ecd.png";